import React from 'react';
import BadgeStatus from '../../../../atoms/BadgeStatus';
import { ChannelPill } from '../shared/channelVisuals';
import { MessageCompositionStudio, StudioMode } from './useMessageCompositionStudio';

const StudioStatusBar: React.FC<{ studio: MessageCompositionStudio; mode: StudioMode }> = ({ studio, mode }) => {
    const { meta, groups, dirty } = studio;
    if (!meta) return null;
    const group = groups.find((g) => g.id === meta.groupId);
    const active = meta.status === 'ACTIVE';
    return (
        <div className="flex flex-wrap items-center gap-3 pt-3">
            <ChannelPill channel={meta.channel} />
            {mode !== 'new' && <BadgeStatus color={active ? 'green' : 'red'} text={active ? 'Ativo' : 'Inativo'} />}
            {meta.channel !== 'INTERNAL_MESSAGE' && (
                <span className="text-xs text-gray-500">{group ? `Grupo ${group.name}` : 'Sem grupo'}</span>
            )}
            {mode !== 'view' && (
                <span className={`text-xs ${dirty ? 'text-amber-600' : 'text-gray-400'}`}>
                    {dirty ? '● Alterações não salvas' : 'Nenhuma alteração'}
                </span>
            )}
        </div>
    );
};

export default StudioStatusBar;
